import {
  Component,
  EventEmitter,
  Output,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PaginatorComponent {
  @Output() public pageChange = new EventEmitter();

  public pageCount: number = 0;
  public entriesPerPage: number = 0;
  public selectedPage: number = 1;

  getSelectedPage(): number {
    return this.selectedPage;
  }

  updateData(pageCount: number, entriesPerPage: number) {
    this.pageCount = pageCount > 0 ? pageCount : 0;
    this.entriesPerPage = entriesPerPage;

    if (this.selectedPage > this.pageCount) {
      this.selectedPage = this.pageCount;
    }
  }

  public setPage(pageNumber: number, notify: boolean = true): void {
    if (pageNumber >= 1 && pageNumber <= this.pageCount) {
      this.selectedPage = pageNumber;
      if (notify) {
        this.pageChange.emit();
      }
    }
  }

  setFirstPage(): void {
    if (this.selectedPage !== 1) {
      this.setPage(1);
    }
  }

  setLastPage(): void {
    if (this.selectedPage !== this.pageCount) {
      this.setPage(this.pageCount);
    }
  }

  setNextPage(): void {
    const page = this.selectedPage + 1;

    if (page <= this.pageCount) {
      this.setPage(page);
    }
  }

  setPreviousPage(): void {
    const page = this.selectedPage - 1;

    if (page >= 1 && page <= this.pageCount) {
      this.setPage(page);
    }
  }

  reset() {
    this.selectedPage = 1;
  }
}
